'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const {name, code, encode, decode} = {
  name: 'json',
  code: 512,
  encode: json => new TextEncoder().encode(JSON.stringify(json)),
  decode: bytes => JSON.parse(new TextDecoder().decode(bytes))
};

exports.code = code;
exports.decode = decode;
exports.encode = encode;
exports.name = name;
